var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComparativeAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2 0C54.6359 0 55.8194 1.09378 55.9812 2.50291L56 2.83333L56 65.1667C56 66.6197 54.9191 67.8173 53.5265 67.9809L53.2 68L36.4 68C34.8536 68 33.6 66.7315 33.6 65.1667C33.6 63.7136 34.6809 62.5161 36.0735 62.3524L36.4 62.3333L50.4 62.3333L50.4 5.66667L25.2538 5.66614L5.6 6.04633L5.6 36.8333C5.6 38.2864 4.51909 39.4839 3.12654 39.6476L2.8 39.6667C1.36406 39.6667 0.18058 38.5729 0.0188376 37.1638L0 36.8333L0 3.26923C0 1.83591 1.05283 0.647486 2.42434 0.461261L2.74616 0.436421L25.2 0L53.2 0Z",
    transform: "matrix(-1 0 0 1 84 8)",
    id: "Path-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 0C26.6359 0 27.8194 1.09378 27.9812 2.50291L28 2.83333L28 65.1667C28 66.6197 26.9191 67.8173 25.5265 67.9809L25.2 68L14 68C12.4536 68 11.2 66.7315 11.2 65.1667C11.2 63.7136 12.2809 62.5161 13.6735 62.3524L14 62.3333L22.4 62.3333L22.4 5.66667L2.8 5.66667C1.36406 5.66667 0.18058 4.57289 0.0188376 3.16376L0 2.83333C0 1.3803 1.08091 0.18273 2.47346 0.0190619L2.8 0L25.2 0Z",
    transform: "matrix(-1 0 0 1 34 14)",
    id: "Path-2-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L14.1667 17C15.7315 17 17 15.7315 17 14.1667L17 2.83333C17 1.26853 15.7315 0 14.1667 0ZM11.3333 5.66667L11.3333 11.3333L5.66667 11.3333L5.66667 5.66667L11.3333 5.66667Z",
    transform: "translate(39 22)",
    id: "Rectangle",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0C12.7464 0 14 1.34315 14 3C14 4.53851 12.9191 5.80652 11.5265 5.97982L11.2 6L2.8 6C1.2536 6 0 4.65685 0 3C0 1.46149 1.08091 0.193479 2.47346 0.0201832L2.8 0L11.2 0Z",
    transform: "translate(59 28)",
    id: "Path-4-Copy-2",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C9.76878 0 11 1.34315 11 3C11 4.53851 9.93839 5.80652 8.57071 5.97982L8.25 6L2.75 6C1.23122 6 0 4.65685 0 3C0 1.46149 1.06161 0.193479 2.42929 0.0201832L2.75 0L8.25 0Z",
    transform: "translate(14 25)",
    id: "Path-4-Copy-3",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C9.76878 0 11 1.34315 11 3C11 4.53851 9.93839 5.80652 8.57071 5.97982L8.25 6L2.75 6C1.23122 6 0 4.65685 0 3C0 1.46149 1.06161 0.193479 2.42929 0.0201832L2.75 0L8.25 0Z",
    transform: "translate(14 36)",
    id: "Path-4-Copy-4",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C9.76878 0 11 1.34315 11 3C11 4.53851 9.93839 5.80652 8.57071 5.97982L8.25 6L2.75 6C1.23122 6 0 4.65685 0 3C0 1.46149 1.06161 0.193479 2.42929 0.0201832L2.75 0L8.25 0Z",
    transform: "translate(14 48)",
    id: "Path-4-Copy-6",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C9.76878 0 11 1.34315 11 3C11 4.53851 9.93839 5.80652 8.57071 5.97982L8.25 6L2.75 6C1.23122 6 0 4.65685 0 3C0 1.46149 1.06161 0.193479 2.42929 0.0201832L2.75 0L8.25 0Z",
    transform: "translate(14 59)",
    id: "Path-4-Copy-5",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4349 0C21.3049 0 27.6849 6.59994 27.6849 14.7414C27.6849 22.8828 21.3049 29.4828 13.4349 29.4828C7.45365 29.4828 2.17199 25.6352 0.0968183 19.9403C-0.195393 19.1384 0.196131 18.2433 0.971312 17.941C1.74649 17.6387 2.61178 18.0437 2.90399 18.8457C4.54221 23.3414 8.71244 26.3793 13.4349 26.3793C19.6481 26.3793 24.6849 21.1688 24.6849 14.7414C24.6849 8.31393 19.6481 3.10345 13.4349 3.10345C9.23473 3.10345 5.44617 5.50426 3.50313 9.26939C3.11299 10.0254 2.20428 10.3111 1.47347 9.90749C0.742665 9.50389 0.466504 8.56384 0.856649 7.80783C3.31624 3.04175 8.11623 0 13.4349 0Z",
    transform: "matrix(-0.7071067 0.7071068 0.7071068 0.7071067 62.894287 37.29897)",
    id: "Path",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0C3.41954 0 4.38067 0.923102 4.4897 2.10342L4.5 2.32759L4.5 16.2931C4.5 17.5786 3.49264 18.6207 2.25 18.6207C1.08046 18.6207 0.119327 17.6976 0.0102999 16.5173L0 16.2931L0 2.32759C0 1.0421 1.00736 0 2.25 0Z",
    transform: "matrix(-0.7071067 0.7071068 0.7071068 0.7071067 73.07606 64.55534)",
    id: "Path-17",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z",
    transform: "translate(70 45)",
    id: "Oval",
    fill: "#0B67B2",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparativeAnalysis);
export default __webpack_public_path__ + "static/media/comparativeAnalysis.f1d025903ca823211d5a339f143443ee.svg";
export { ForwardRef as ReactComponent };